<template>
  <v-card hover @click="goToPatient">
    <v-card-title class="name-title">
      <v-layout row>
        <v-icon left>person</v-icon>
        <span class="family-name">{{this.patient.name[0].family}}</span>, {{this.patient.name[0].given}}
      </v-layout>
    </v-card-title>
    {{getPrimaryId.value}}
  </v-card>
</template>
<script>
export default {
  props: ['patient'],
  methods: {
    goToPatient () {
      console.log('card clicked')
      this.$router.push({ name: 'patient-overview', params: { patientId: this.patient.systemId } })
    }
  },
  computed: {
    getPrimaryId () {
      if (this.patient.identifier.length > 1) return this.patient.identifier[1]
      return this.patient.identifier[0]
    }
  }
}
</script>

<style scoped>
.name-title {
  font-size: 1.3em;
  width: 100%;
}
.family-name {
  color: #1ea5a5;
  text-transform: uppercase;
}
</style>
